import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {CachePresenze} from "@commons/mapping/CachePresenze";

export class SpecificheDiProduzione {
    private gestione: GestionePlusData;
    private readonly cache: CachePresenze;

    constructor(gestione: GestionePlusData, cache: CachePresenze,) {
        this.gestione = gestione;
        this.cache = cache;
    }

    static coalesce = (value: string | null | undefined, valueIfNull: string) => {
        if (!value) {
            return valueIfNull;
        }
        return value;
    };

    public isGiuDiSpecifica = (giustificativo: GiustificativoRecord) => {
        const proprietaGestione = this.gestione.proprietaGestione!;
        if (giustificativo !== null && giustificativo.codGiu !== '') {

            if (giustificativo.codGiu === proprietaGestione.codGiuSpecificaOD) {
                return true;
            } else if (giustificativo.codGiu === proprietaGestione.codGiuSpecificaON) {
                return true;
            }
        }
        return false;
    };

    public caricaGiu = (day: PresenzeGiornataPlusRecord) => {
        const proprietaGestione = this.gestione.proprietaGestione!;
        //this.effettive[].entrataTerminale
        //this.effettive[].uscitaTerminale
        //this.arrotondate = []

        if (SpecificheDiProduzione.coalesce(proprietaGestione.codGiuSpecificaOD, '') !== '' && SpecificheDiProduzione.coalesce(proprietaGestione.codGiuSpecificaON, '') !== '') {
            let codTerminale = null;
            for (let indTimb = 0; indTimb < day.effettive.length; ++indTimb) {
                const timbratura = day.effettive[indTimb];
                if (timbratura !== null) {
                    if (indTimb === 0) {
                        codTerminale = timbratura.entrataTerminale;
                    }
                    if (proprietaGestione.quantitaTimbrature === 'UNA' && day.effettive.length === 1) { // se una sola timbratura
                        if (codTerminale === null || codTerminale === '') { // il codice terminale è quello delle timbratura in ingresso o eventualmente quello della timb in uscita
                            codTerminale = timbratura.uscitaTerminale;
                        }
                    } else {
                        if (!((timbratura.entrataTerminale === timbratura.uscitaTerminale) && (codTerminale === timbratura.entrataTerminale))) {
                            codTerminale = null;
                            break;
                        }
                    }
                }
            }

            const terminale = this.getTerminale(codTerminale);
            /*
                terminale.idGruppoValori
                terminale.codValore
            */
            const codSpecifica = terminale !== null ? terminale.codValore : '';
            let totOreOrdDiurne = day.totali!.hOrdDiurne;
            let totOreOrdNotturne = day.totali!.hOrdNotturne;
            let insSpecificaOD = true;
            let insSpecificaON = true;
            let mancaSpecifica = false;

            // verifico compilazione specifica per giustificativi orari, come ad esempio quelli relativi allo straordinario
            for (let indGiu = 0; indGiu < day.causaliHH.length; ++indGiu) {
                const causale = day.causaliHH[indGiu];
                if (causale) {
                    const giustificativo = this.getGiustificativo(causale.codGiu);
                    if (giustificativo !== null && giustificativo.specificaValore) {
                        if (terminale !== null && giustificativo.idGruppoValori === terminale.idGruppoValori) {
                            if (causale.valoreEvento === null || causale.valoreEvento === '') {
                                causale.valoreEvento = codSpecifica;
                            }
                        }
                        if (causale.valoreEvento === null || causale.valoreEvento === '') {
                            mancaSpecifica = true;
                        }
                    }
                }
            }

            // verifico compilazione specifica per giustificativi ore ordinarie (diurne/notturne), caricamento degli stessi se primo calcolo!
            for (let indGiu = 0; indGiu < day.causaliQI.length; ++indGiu) {
                const causale = day.causaliQI[indGiu];
                if (causale) {
                    let quantitaCausale;
                    if (causale.codGiu === proprietaGestione.codGiuSpecificaOD) {
                        quantitaCausale = Math.round(causale.quantita * 60000) / 1000;
                        totOreOrdDiurne -= quantitaCausale;
                        insSpecificaOD = false;
                        if (causale.valoreEvento === null || causale.valoreEvento === '') {
                            mancaSpecifica = true;
                        }
                    }
                    if (causale.codGiu === proprietaGestione.codGiuSpecificaON) {
                        quantitaCausale = Math.round(causale.quantita * 60000) / 1000;
                        totOreOrdNotturne -= quantitaCausale;
                        insSpecificaON = false;
                        if (causale.valoreEvento === null || causale.valoreEvento === '') {
                            mancaSpecifica = true;
                        }
                    }
                }
            }
            const newCausaliQI = [];
            if (insSpecificaOD && totOreOrdDiurne > 0) {
                const causale = PresenzeGiustificativo.factory({codGiu: proprietaGestione.codGiuSpecificaOD, tipoGiu: 'EVENTO'});
                causale.quantita = totOreOrdDiurne / 60;
                causale.valoreEvento = codSpecifica;
                newCausaliQI.push(causale);
            } else {
                totOreOrdDiurne = Math.round(totOreOrdDiurne * 1000) / 1000;
                if (totOreOrdDiurne !== 0) {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 22);
                }
            }
            if (insSpecificaON && totOreOrdNotturne > 0) {
                const causale = PresenzeGiustificativo.factory({codGiu: proprietaGestione.codGiuSpecificaON, tipoGiu: 'EVENTO'});
                causale.quantita = totOreOrdNotturne / 60;
                causale.valoreEvento = codSpecifica;
                newCausaliQI.push(causale);
            } else {
                totOreOrdNotturne = Math.round(totOreOrdNotturne * 1000) / 1000;
                if (totOreOrdNotturne !== 0) {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 22);
                }
            }

            const count = PresenzeGiornataPlusRecord.addCausaliQI(day, newCausaliQI, GestionePlus.maxCausaliQI);

            if (newCausaliQI.length === 0 && mancaSpecifica) {
                PresenzeGiornataPlusRecord.setAnomalia(day, 23);
            } else if (count === newCausaliQI.length && count > 0) {
                if (codSpecifica === '') {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 23);
                }
            } else if (count < newCausaliQI.length) {
                console.error(GestionePlus.formatDate(day.dtGiornata), 'Raggiunto il limite massimo di causali!');
                PresenzeGiornataPlusRecord.setAnomalia(day, 11);
            }
        }
    }

    private getTerminale = (codTerminale: string | null) => this.cache.terminali.find(terminale => terminale.codTerminale === codTerminale) || null;

    private getGiustificativo = (codGiu: string) => this.cache.getGiustificativo(codGiu);
}
